import clsx from "clsx";
import type { ButtonHTMLAttributes, HTMLAttributes, PropsWithChildren, ReactNode } from "react";

export function Button({ className, children, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button className={clsx("k-button", className)} {...props}>
      {children}
    </button>
  );
}

export function Badge({ className, children, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={clsx("k-badge", className)} {...props}>
      {children}
    </span>
  );
}

export function EmptyState({ icon, title, body, action }: { icon?: ReactNode; title: string; body: string; action?: ReactNode }) {
  return (
    <div className="k-empty" role="status">
      {icon ? <div className="k-empty__icon">{icon}</div> : null}
      <strong>{title}</strong>
      <p>{body}</p>
      {action}
    </div>
  );
}

export function Skeleton({ className }: { className?: string }) {
  return <span className={clsx("k-skeleton", className)} aria-hidden="true" />;
}

export function VisuallyHidden({ children }: PropsWithChildren) {
  return <span className="k-visually-hidden">{children}</span>;
}
